/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//Add option for jquery "when" to receive array of ajax calls
if (typeof jQuery.when.all === 'undefined') {
  jQuery.when.all = function (deferreds) {
    return $.Deferred(function (def) {
      $.when.apply(jQuery, deferreds).then(
        // the calling function will receive an array of length N, where N is the number of
        // deferred objects passed to when.all that succeeded. each element in that array will
        // itself be an array of 3 objects, corresponding to the arguments passed to jqXHR.done:
        // ( data, textStatus, jqXHR )
        function () {
          var arrayThis, arrayArguments;

          if (Array.isArray(this)) {
            arrayThis = this;
            arrayArguments = arguments;
          }
          else {
            arrayThis = [this];
            arrayArguments = [arguments];
          }

          def.resolveWith(arrayThis, [Array.prototype.slice.call(arrayArguments)]);
        },
        // the calling function will receive an array of length N, where N is the number of
        // deferred objects passed to when.all that failed. each element in that array will
        // itself be an array of 3 objects, corresponding to the arguments passed to jqXHR.fail:
        // ( jqXHR, textStatus, errorThrown )
        function () {
          var arrayThis, arrayArguments;

          if (Array.isArray(this)) {
            arrayThis = this;
            arrayArguments = arguments;
          }
          else {
            arrayThis = [this];
            arrayArguments = [arguments];
          }

          def.rejectWith(arrayThis, [Array.prototype.slice.call(arrayArguments)]);
        });
    });
  }
}

if (typeof Dtails === "undefined") {
  var Dtails = {};
}

Dtails.AutomaticDiscount = {
  api_service: 'https://raasdal-service.herokuapp.com/discounts/auto',
  // api_service: 'https://raasdal.glitch.me/autodiscount',
  // api_service: 'https://raasdal.eu.ngrok.io/discounts/auto',
  load: function () {
    var _this = this;
    var discount_code = Cookies.get('discount_code')
    if (discount_code) {
      this.discount_code = discount_code
      //Always show banner, even with normal discount codes
      this.addBanner()

      var automatic_discount = Cookies.get('automatic_discount') ? JSON.parse(Cookies.get('automatic_discount')) : null;
      // We've already fetched the auto discount and saved as a cookie
      if (automatic_discount && automatic_discount.code == discount_code) {
        _this.setAutomaticDiscount()
        return
      }

      $.ajax({
        dataType: "json",
        url: this.api_service,
        data: { code: discount_code },
        headers: { 'x-shopify-shop-domain': window.theme.store },
        success: function (data) {
          if (data.match) {
            _this.setAutomaticDiscount(data)
          } else {
            _this.removeAutomaticDiscount()
          }
        }
      })
        .fail(function () {
          console.log("discount not found");
          _this.removeAutomaticDiscount()
        })
    } else if (Cookies.get('automatic_discount')) {
      //Remove auto discount in case Shopifys discount code has been removed
      _this.removeAutomaticDiscount()
    }

  },
  setAutomaticDiscount: function (data) {
    if (data) {
      Cookies.set('automatic_discount', JSON.stringify(data))
    }
    this.automatic_discount = JSON.parse(Cookies.get('automatic_discount'));
    this.setCartListeners()
  },
  removeAutomaticDiscount: function () {
    Cookies.remove('automatic_discount')
  },
  addBanner: function () {
    var $banner = $('.automatic-discount-banner')
    if (window.languages.discountCodeAnnouncement) {
      $('[data-section-type="announcement-bar"]').hide()
      $banner.find('p').html(window.languages.discountCodeAnnouncement.replace('{{ code }}', this.discount_code))
      $banner.show()
    }
  },
  setCartListeners: function () {
    document.addEventListener('product:added', function (event) {
      this._checkAddedItems()
    }.bind(this));

    document.addEventListener('cart:updated', function (event) {
      var cart = event.detail ? event.detail.cart : null
      this._checkAddedItems(cart)
    }.bind(this));

    // Set custom checkout disable. In case you change quantity line items with input field,
    // we need to disabled go to checkout until you click outside. This give time for updates to take effect
    $(document).on('focusin', '.QuantitySelector__CurrentQuantity', function (e) {
      $('.Cart__Checkout').prop('disabled', true)
    }.bind(this))

    $(document).on('focusout', '.QuantitySelector__CurrentQuantity', function (e) {
      $('.Cart__Checkout').prop('disabled', false)
    }.bind(this))
  },
  _checkAddedItems: function (cart) {
    if (cart) {
      this.checkAddedItems(cart)
    } else {
      $.getJSON(window.routes.cartUrl + '.json', function (cart) {
        this.checkAddedItems(cart)
      }.bind(this))
    }
  },
  checkAddedItems: function (cart) {
    var _this = this

    var items = []
    //Let's combine line items that may be split because of different properties. We are interested in merging the quantities
    cart.items.forEach(function (item) {
      // Don't add item if it's part of a bundle. We assume nested bundled items don't qualify for automatic discounts
      if (item.properties['_parent_bundle_id']) return

      var existing = items.findIndex(function (v) { return v.variant_id == item.variant_id });
      if (existing > -1) {
        items[existing].quantity += item.quantity
      } else {
        items.push(item);
      }
    });
    var matches = items.filter(function (item) {
      return _this.automatic_discount.prerequisite_variant_ids.indexOf(item.variant_id) > -1 && item.quantity >= _this.automatic_discount.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity
    });
    var quantity_to_add = 0;
    var allocation_limit = 0;
    for (var i = 0; i < matches.length; i++) {
      var match = matches[i]
      var match_times = Math.floor(match.quantity / _this.automatic_discount.prerequisite_to_entitlement_quantity_ratio.prerequisite_quantity)

      for (var ii = 0; ii < match_times; ii++) {
        if (allocation_limit < _this.automatic_discount.allocation_limit) {
          quantity_to_add += _this.automatic_discount.prerequisite_to_entitlement_quantity_ratio.entitled_quantity
          // For every match, we allocate one usage
          allocation_limit += 1;
        }
      }
    }
    var entitled_variant_id = _this.automatic_discount.entitled_variant_ids[0] // For now let's just assume there is only one variant to add for free
    var entitled_item = items.find(function (i) { return i.variant_id == entitled_variant_id && i.properties['_automatic_discount'] })

    if (entitled_item && entitled_item.quantity == quantity_to_add) return // No changes needed


    if (entitled_item) {
      var url = window.routes.cartChangeUrl + '.js'
      var body = { id: entitled_item.key, quantity: quantity_to_add, properties: { _automatic_discount: _this.automatic_discount.code } }
    } else {
      var url = window.routes.cartAddUrl + '.js'
      var body = { items: [{ id: entitled_variant_id, quantity: quantity_to_add, properties: { _automatic_discount: _this.automatic_discount.code } }] }
    }
    fetch(url, {
      body: JSON.stringify(body),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (cart) {
      // Add slight delay. Unfortunately we have to as there are animations on the cart drawer
      setTimeout(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }, 500)
    });
  }
}

Dtails.cartEnableTerms = function () {
  document.addEventListener('click', function (e) {
    if (!e.target.closest('button[name="checkout"]')) return;
    document.querySelector('.Form__CheckboxError').style.display = 'none';
    var termsCheckbox = document.getElementById('CartTerms')
    if (termsCheckbox.checked) {
      return true;
    } else {
      e.preventDefault();
      document.querySelector('.Form__CheckboxError').style.display = 'block';
    }
  }, false);
}

Dtails.RebuyModal = {
  rebuy_base_url: document.location.search.indexOf('disable_rebuy_cache=true') > -1 ? 'https://rebuyengine.com/api/v1' : 'https://raasdal-service.herokuapp.com/api/v1', //https://rebuyengine.com/ //https://raasdal-service.herokuapp.com/api/v1
  init: function () {
    if (!window.rebuy_modal_settings || !window.rebuy_modal_settings.api_key || !window.rebuy_modal_settings.data_source) return

    this.page_has_rebuy = true
    this.api_key = window.rebuy_modal_settings.api_key
    this.data_source = window.rebuy_modal_settings.data_source
    this.product_limit = window.rebuy_modal_settings.product_limit ? parseInt(window.rebuy_modal_settings.product_limit) : 4;

    this.$rebuyModal = $('[data-rebuy-modal]')
    this.$rebuyModalContent = $('[data-rebuy-content]', this.$rebuyModal)

    // this.product_id = this.$rebuyModal.data('product-id')

    this.product_forms = {}

    $(document).on('product:added', this.fetchRebuyProducts.bind(this))

    $('[data-action="close-modal"]', this.$rebuyModal).on('click', this.closeModal.bind(this));

  },
  fetchRebuyProducts: function (e) {
    this.product_id = e.detail.product_id

    if (!this.product_id) return

    this.page_has_rebuy = true

    this.loading = true
    $.getJSON(this.rebuy_base_url + '/custom/id/' + this.data_source + '?shopify_product_ids=' + this.product_id + '&limit=' + this.product_limit + '&key=' + this.api_key, function (response) {
      if (response.data.length > 0) {
        this.rebuy_products = response.data
        this.fetchProductsForModal()
      } else {
        this.unbindRebuy()
      }
    }.bind(this))
  },
  unbindRebuy: function () {
    this.page_has_rebuy = false
    document.documentElement.dispatchEvent(new CustomEvent('rebuy:closed', {
      bubbles: true
    }));
  },
  fetchProductsForModal: function () {

    var queryString = this.getSearchQueryString(this.rebuy_products)

    $.get(window.routes.searchUrl + '?view=rebuy&type=product&q=' + queryString, function (response) {
      // Use original rebuy data to get sort order
      // var products_html = this.rebuy_products.map(function(p){
      //   return response[p.id]
      // });
      var products_html = Object.values(response);
      if (products_html.length) {
        this.$rebuyModalContent.html(products_html.join(''));
        this.initModalForms()
        this.openModal()
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('rebuy:closed', {
          bubbles: true
        }));
      }
      this.loading = false
    }.bind(this), 'json')

  },
  getSearchQueryString: function (items) {
    return items.map(function (item) {
      return 'id:' + item.id;
    }).join(' OR ');
  },
  initModalForms: function () {
    var _this = this
    this.$rebuyModalContent.find('[data-rebuy-item] [data-action="add-to-cart"]').attr('disabled', true)
    this.$rebuyModalContent.find('[data-rebuy-item]').each(function () {
      var $this = $(this)
      var id = $this.data('rebuy-item')
      var productVariants = new window.theme.ProductVariants($(this)[0], { useAjaxCart: true, contain_events: true, showPriceInButton: false, preferredSelectorPosition: 'top' });
      _this.product_forms[id] = {
        productVariants: productVariants
      }
      $this.find('[data-action="add-to-cart"]').attr('disabled', false)
      $this.on('product:added', function () {
        $this.find('button.ProductForm__AddToCart').addClass('ProductForm__AddToCart--added')
      }.bind(this))
      $this.on('variant:changed', function (event) {
      }.bind(this))
    })
  },
  openModal: function () {
    var _this = this
    this.pageOverlayElement = document.querySelector('.PageOverlay');
    modal = this.$rebuyModal[0]

    this.activeModal = modal;

    if (document.documentElement.classList.contains('no-scroll')) {
      this.wasLocked = true;
    }

    this.activeModal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');

    this.pageOverlayElement.classList.add('is-visible');
  },
  closeModal: function () {
    // this.pageOverlayElement.classList.remove('is-visible');

    this.activeModal.setAttribute('aria-hidden', 'true');
    this.activeModal = null;
    this.page_has_rebuy = false;

    document.documentElement.dispatchEvent(new CustomEvent('rebuy:closed', {
      bubbles: true
    }));

    if (!this.wasLocked) {
      document.documentElement.classList.remove('no-scroll');
    }
  },
  isActive: function () {
    return this.page_has_rebuy
  }
}

Dtails.productCartAjax = function () {
  //Fetch products based on handles with search
  var bundleHandleArr = [];
  $('[data-product-item-form] [data-collection-bundle-json]').each(function () {
    let jsonBundle = JSON.parse($(this).html().trim());
    for (bundle of jsonBundle) {
      if (bundleHandleArr.indexOf(bundle.handle) < 0) {
        bundleHandleArr.push(bundle.handle);
      }
    }
  });
  if (bundleHandleArr.length) {
    var queryString = bundleHandleArr.map(function (handle) {
      return 'handle:' + handle;
    }).join(' OR ');
    $.get(window.routes.searchUrl + '?view=bundle&type=product&q=' + queryString, function (response) {
      let arrBundleFromSearch = JSON.parse(response);
      $('[data-product-item-form] [data-collection-bundle-json]').each(function () {
        let jsonBundle = JSON.parse($(this).html().trim());
        let bundleArrFinal = [];

        for (bundle of jsonBundle) {
          let isMatched = false;
          for (item of arrBundleFromSearch) {
            if (item.bundle_handle.toLowerCase() == bundle.handle.toLowerCase()) {
              bundle.product_id = item.product_id;
              bundle.title = bundle.quantity + ' x ' + item.title;
              bundle.variants = [];

              // sort first selected or available variant to be first element in array
              for (variant of item.variants) {
                if (variant.id == item.active_variant_id) {
                  bundle.variants.push(variant);
                }
              }
              for (variant of item.variants) {
                if (variant.id != item.active_variant_id) {
                  bundle.variants.push(variant);
                }
              }

              bundleArrFinal.push(bundle);
              isMatched = true;
            }
          }
          if (!isMatched) {
            bundle.product_id = '';
            bundle.title = '';
            bundle.variants = [
              {
                "id": "",
                "title": "",
                "stock_text_type": "soldout",
                "stock_backinstock_date_ymd": "1970-01-01",
                "stock_backinstock_date": "01-01-70",
                "stock_backinstock_text": ""
              }
            ]
            bundleArrFinal.push(bundle);
          }
        }
        $(this).closest('[data-product-item-form]').find('[product-bundle-json-blank]').text(JSON.stringify(bundleArrFinal));
        $(this).closest('[data-product-item-form]').find('[product-bundle-json-blank]').attr('data-bundle-json', '');
      });

      //Add ATC/form functionality to all product items on collection pages
      $('[data-product-item-form]').each(function () {
        var $this = $(this)
        var productVariants = new window.theme.ProductVariants($(this)[0], { useAjaxCart: true });
        // $this.on('product:added', function(){
        //   $this.find('button.ProductForm__AddToCart').addClass('ProductForm__AddToCart--added')
        // }.bind(this))
      })

    }.bind(this));
  } else {
    //Add ATC/form functionality to all product items on collection pages
    $('[data-product-item-form]').each(function () {
      var $this = $(this)
      var productVariants = new window.theme.ProductVariants($(this)[0], { useAjaxCart: true });
      // $this.on('product:added', function(){
      //   $this.find('button.ProductForm__AddToCart').addClass('ProductForm__AddToCart--added')
      // }.bind(this))
    })
  }
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
Dtails.DiscountUpsell = {
  rebuy_base_url: document.location.search.indexOf('disable_rebuy_cache=true') > -1 ? 'https://rebuyengine.com' : 'https://raasdal-service.herokuapp.com', //
  total_price: 0,
  total_discount: 0,
  initGlobalEventHandlers: function () {
    document.addEventListener('cart:updated', debounce(this._onCartUpdated.bind(this), 200));
  },
  init: function () {
    if (!window.rebuy_discount_upsell_settings || !window.rebuy_discount_upsell_settings.api_key) return

    this.loading(true)

    this.page_has_rebuy = true
    this.api_key = window.rebuy_discount_upsell_settings.api_key
    this.product_id = window.rebuy_discount_upsell_settings.product_id
    this.discount_sources = []
    this.gift_sources = []

    this.$container = $('[data-rebuy-discount-upsell]')
    this.$containergift = $('[data-rebuy-gift-product]')

    this.content = document.querySelector('[data-rebuy-discount-upsell] .discount-upsell__list')
    this.showSaveUpToLabel = this.$container.data('show-save-upto-label')
    this.content.style.display = "block"
    that = this
    this.showMoreButtons = document.querySelectorAll('.discount-upsell__showmore')

    this.showMoreButtons.forEach((button) => {
      button.addEventListener("click", this.showMore.bind(this))
    })
    document.addEventListener('product:added', this._onProductAdded.bind(this))
    this.fetchRebuyProducts()
    addEventListener('resize', debounce(this.resizeGiftProduct.bind(this), 300));
  },

  resizeGiftProduct: function () {

    if (window.innerWidth < 1008) {
      let k = document.querySelector(".rebuy-gift-product-lap-and-up").innerHTML;

      if (k != null) {
        document.querySelector(".rebuy-gift-product-mobile").innerHTML = k;
        document.querySelector(".rebuy-gift-product-lap-and-up").length = 0;
      }
    }
  },
  showMore: function (e) {
    var button = e.target
    if (button.classList.contains("show-more")) {
      button.classList.remove("show-more");
      button.innerHTML = button.getAttribute("data-show-less");
      document.querySelectorAll(".discount-upsell__list li").forEach((input) => {
        input.style.display = "flex";
      });
    } else {
      button.classList.add("show-more");
      button.innerHTML = button.getAttribute("data-show-more");
      this.$container.each(function () {
        $(this).find('.discount-upsell__list li').each(function (idx) {
          if (idx > 3) {
            $(this).hide()
          }
        })
        if ($(this).is(':visible')) {
          $('html, body').animate({
            scrollTop: $(this).offset().top - 50
          });
        }
      })
    }
  },
  loading: function (loading) {
    if (loading) {
      $('[data-action="add-to-cart"]').attr('disabled', 'disabled')
    } else {
      $('[data-action="add-to-cart"]').attr('disabled', null)
    }
  },
  collectionInit: function () {
    if (!window.rebuy_discount_upsell_settings || !window.rebuy_discount_upsell_settings.api_key) return
    this.api_key = window.rebuy_discount_upsell_settings.api_key

    this.fetchRebuySources()
    $('[data-action="add-to-cart"]').attr('disabled', null)

    document.addEventListener('product:added', this._onCollectionProductAdded.bind(this));
  },
  _onCollectionProductAdded: function (event) {

    var product_id = event.detail.product_id
    if (!product_id) return

    var _this = this

    var rebuy_sources = this.rebuy_sources.filter(function (source) { return source.name.indexOf('100%') > -1 })
    var rebuy_sources_gift_product = this.rebuy_sources_gift_product;
    var discount_sources = []
    var requests = rebuy_sources.map(function (source) {
      var url = _this.rebuy_base_url + source.id + '?shopify_product_ids=' + product_id + '&key=' + _this.api_key
      return $.getJSON(url, function (response) {
        var discount_percent = source.name.split(' ')[1]
        discount_sources.push({
          id: source,
          products: response.data,
          name: source.name,
          discount_percent: parseInt(discount_percent)
        })
      })
    })
    $.when.all(requests).then(function (objects) {
      var item_added = event.detail.items ? event.detail.items[0] : null
      if (item_added) {
        var discount_id = item_added.key
        var items = []
        var variants = discount_sources.reduce(function (acc, d_source) {
          if (d_source.discount_percent == 100) {
            acc = acc.concat(d_source.products.flatMap(function (p) { return p.variants }))
          }
          return acc
        }, [])
        if (variants.length > 0) {
          variants.forEach(function (variant) {
            var item = {
              id: variant.id,
              quantity: 1,
              properties: {
                _discount_upsell: 100,
                _discount_parent: discount_id,
                _discount_quantity: 1
              }
            };
            items.push(item)
          })
          //Combine duplicates into one line
          var combined_items = items.reduce(function (acc, item) {
            var index = acc.findIndex(function (i) { return i.id === item.id })
            if (index > -1) {
              acc[index].quantity += 1
              acc[index].properties._discount_quantity += 1
            } else {
              item.quantity = 1
              acc.push(item)
            }
            return acc
          }, [])
          if (combined_items.length > 0) {
            fetch(window.routes.cartAddUrl + '.js', {
              body: JSON.stringify({ items: combined_items }),
              credentials: 'same-origin',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
              }
            }).then(function (cart) {
              // Add slight delay. Unfortunately we have to as there are animations on the cart drawer
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            });
          }
        }
      }
    });

    // gift product collection add auto
    let gift_sources = [];
    const requestgiftproduct = this.rebuy_sources_gift_product.map(function (source) {
      let url = _this.rebuy_base_url + source.id + '?shopify_product_ids=' + product_id + '&key=' + _this.api_key
      return $.getJSON(url, function (response) {
        gift_sources.push({
          id: source,
          products: response.data,
          name: source.name,
          discount_percent: 100,
          metadata: response.metadata
        })
      })
    })

    fetch(window.routes.cartUrl + '.js').then(function (cart) {
      return cart.json();
    }).then(function (data) {
      const found_parent_variant = new Set()
      // update gift free product
      if (data.items.length) {
        var to_be_updated = {}
        for (var i = 0; i < data.items.length; i++) {
          let item = data.items[i]
          if (item.properties._variant_id_parent && item.properties._type_free_product) {
            let found_parent = data.items.find(function (it) {
              return it.variant_id == item.properties._variant_id_parent
            })

            let found_parent_bundle = data.items.filter(function (it, index) {
              if (it.variant_id == item.properties._variant_id_parent && it.properties._bundle_id) {
                return it;
              }
            })

            if (found_parent) {
              found_parent_variant.add(found_parent.variant_id)
              // add check update or add cart
              if (found_parent_bundle && found_parent_bundle.length) {
                to_be_updated[item.key] = found_parent_bundle.length
              } else {
                // 100% discount only. Let's try to figure out how many there should be
                if (item.properties._discount_upsell == 100 && (found_parent.quantity * item.properties._discount_quantity) != item.quantity) {
                  // Quantity doesn't match, let's add it to update
                  to_be_updated[item.key] = found_parent.quantity * item.properties._discount_quantity
                }
              }
            }
          }
        }
        if (Object.keys(to_be_updated).length > 0) {
          var url = window.routes.cartUpdateUrl + '.js'
          var body = { updates: to_be_updated }
          fetch(url, {
            body: JSON.stringify(body),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (cart) {
            return cart
          }).then(function () {
            setTimeout(function () {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }, 500)
          });
        }
      }
      return found_parent_variant;
    }).then(function (dataParent) { // type: set
      $.when.all(requestgiftproduct).then(function (objects) {
        let item_added = event.detail.items ? event.detail.items[0] : null
        let items = []
        if (item_added && !dataParent.has(item_added.variant_id)) {
          let discount_id = item_added.key
          let variant_id_parent = item_added.variant_id
          let gift_sources_variant = _this.sortProducts(gift_sources)
          gift_sources_variant.forEach(function (variant) {
            var item = {
              id: variant.variant_id,
              quantity: variant.quantity,
              properties: {
                _discount_upsell: 100,
                _discount_parent: discount_id,
                _discount_quantity: variant.quantity,
                _variant_id_parent: variant_id_parent,
                _type_free_product: 'free gift'
              }
            };
            items.push(item)
          })

          let combined_items = items.reduce(function (acc, item) {
            let index = acc.findIndex(function (i) { return i.id === item.id })
            if (index > -1) {
              acc[index].quantity += 1
              acc[index].properties._discount_quantity += 1
            } else {
              item.quantity = item.quantity
              acc.push(item)
            }
            return acc
          }, [])

          if (combined_items.length > 0) {
            fetch(window.routes.cartAddUrl + '.js', {
              body: JSON.stringify({ items: combined_items }),
              credentials: 'same-origin',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
              }
            }).then(function (cart) {
              // Add slight delay. Unfortunately we have to as there are animations on the cart drawer
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            });
          }
        }
      });
    })

  },
  _onCartUpdated: function (event) {
    //Let's remove any possible discount upsell items if the parent product is no longer in the cart
    var cart = event.detail.cart
    let payload = event.detail.payload

    if (cart) {
      var to_be_updated = {}
      for (var i = 0; i < cart.items.length; i++) {
        let item = cart.items[i]
        if (item.properties && item.properties._discount_parent) {
          if (payload.updates) {
            // product just updated is bundle parent
            let found_parent = cart.items.find(function (it) {
              return it.variant_id == item.properties._variant_id_parent && it.key == item.properties._discount_parent
            });
            if (found_parent) {
              if (item.properties._type_free_product == 'free gift') {
                to_be_updated[item.key] = found_parent.quantity * item.properties._discount_quantity;
              }
            } else {
              to_be_updated[item.key] = 0;
            }
          } else {
            let found_parent = cart.items.find(function (it) {
              return it.variant_id == item.properties._variant_id_parent && !it.properties._parent_bundle_id
            });
            if (found_parent) {
              if (item.properties._type_free_product == 'free gift') {
                to_be_updated[item.key] = found_parent.quantity * item.properties._discount_quantity;
              }
            } else {
              to_be_updated[item.key] = 0;
            }
          }
        }
      }

      if (Object.keys(to_be_updated).length > 0) {
        var url = window.routes.cartUpdateUrl + '.js'
        var body = { updates: to_be_updated }
        fetch(url, {
          body: JSON.stringify(body),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (cart) {
          return cart
        }).then(function () {
          setTimeout(function () {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          }, 300)
        });
      }
    }
  },

  _onProductAdded: function (event) {
    const item_added = event.detail.items ? event.detail.items[0] : null;
    const _this = this;
    if (item_added) {
      fetch(window.routes.cartUrl + '.js').then(function (cart) {
        return cart.json();
      }).then(function (data) {
        const found_parent_variant = new Set()
        // update gift free product
        if (data.items.length) {
          var to_be_updated = {}
          for (let i = 0; i < data.items.length; i++) {
            let item = data.items[i]
            if (item.properties) {
              if (item.properties._variant_id_parent) {
                let found_parent_bundle = data.items.filter(function (it, index) {
                  if (it.variant_id == item.properties._variant_id_parent && it.properties._bundle_id) {
                    return it;
                  }
                })

                let found_parent = data.items.find(function (it, index) {
                  return it.variant_id == item.properties._variant_id_parent
                })
                if (found_parent) {
                  found_parent_variant.add(found_parent.variant_id)
                  // add check update or add cart
                  if (found_parent_bundle && found_parent_bundle.length) {
                    to_be_updated[item.key] = found_parent_bundle.length * item.properties._discount_quantity;
                  } else {
                    // 100% discount only. Let's try to figure out how many there should be
                    if (item.properties._discount_upsell == 100 && (found_parent.quantity * item.properties._discount_quantity) != item.quantity) {
                      // Quantity doesn't match, let's add it to update
                      to_be_updated[item.key] = found_parent.quantity * item.properties._discount_quantity
                    } 
                  }

                }
              }
            }
          }

          // if (Object.keys(to_be_updated).length > 0) {
          //   var url = window.routes.cartUpdateUrl + '.js'
          //   var body = { updates: to_be_updated }
          //   fetch(url, {
          //     body: JSON.stringify(body),
          //     credentials: 'same-origin',
          //     method: 'POST',
          //     headers: {
          //       'Content-Type': 'application/json',
          //       'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          //     }
          //   }).then(function (cart) {
          //     return cart
          //   }).then(function () {
          //     setTimeout(function () {
          //       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          //         bubbles: true
          //       }));
          //     }, 200)
          //   });
          // }
        }
        return found_parent_variant;
      }).then(function (dataParent) {
        // type set dataParent
        // add gift free product
        let discount_id = item_added.key
        let variant_id_parent = item_added.variant_id

        let items = []
        
        // if (!dataParent.has(item_added.variant_id)) {
          _this.$containergift.find('form').each(function () {
            let $form = $(this)
            var form_data = $form.serializeArray();

            var form_data_parent_product = $('.Product__InfoWrapper form').serializeArray();

            var quantity = form_data_parent_product.find(function (o) { return o.name == 'quantity' });
            quantity = quantity ? quantity.value : 1;
            var id = form_data.find(function (o) { return o.name == 'id' });
            let quantity_of_gift_free = form_data.find(function (o) { return o.name == 'quantity' });
            quantity_of_gift_free = quantity_of_gift_free ? quantity_of_gift_free.value : 1;
            quantity = quantity_of_gift_free * quantity

            id = id.value;
            // Let's find the line properties from the form and create an object so we retain native properties
            let native_properties = form_data.filter(function (o) { return o.name.indexOf('properties') > -1 })
            native_properties = native_properties.reduce(function (acc, o) {
              var regex = /(?:^(properties\[))(.*?)(?:\])/;
              var name = regex.exec(o.name)[2]; // Use just the value between 'properties[' and ']'
              acc[name] = o.value;
              return acc;
            }, {})

            let item = { id: id, quantity: parseInt(quantity), properties: native_properties };
            item.properties._discount_parent = discount_id;
            item.properties._variant_id_parent = variant_id_parent;
            item.properties._discount_quantity = quantity_of_gift_free;
            item.properties._type_free_product = 'free gift';
            items.push(item);
          });
          _this.$container.find('form').each(function () {
            let $form = $(this)
            if ($form.find('input[name="id"]').is(':checked') && $form.find('input[name="id"]').is(':visible')) {

              let form_data = $form.serializeArray();
              let quantity = form_data.find(function (o) { return o.name == 'quantity' });
              quantity = quantity ? quantity.value : 1;
              let id = form_data.find(function (o) { return o.name == 'id' });
              id = id.value;

              // Let's find the line properties from the form and create an object so we retain native properties
              let native_properties = form_data.filter(function (o) { return o.name.indexOf('properties') > -1 })
              native_properties = native_properties.reduce(function (acc, o) {
                let regex = /(?:^(properties\[))(.*?)(?:\])/;
                let name = regex.exec(o.name)[2]; // Use just the value between 'properties[' and ']'
                acc[name] = o.value;
                return acc;
              }, {})

              let item = { id: id, quantity: parseInt(quantity), properties: native_properties };
              item.properties._discount_parent = discount_id
              item.properties._variant_id_parent = variant_id_parent
              item.properties._discount_quantity = 1
              items.push(item)
            }
          })
          //Combine duplicates into one line
          let combined_items = items.reduce(function (acc, item) {
            let index = acc.findIndex(function (i) { return i.id === item.id && i.properties == item.properties })
            if (index > -1) {
              acc[index].quantity += 1
              acc[index].properties._discount_quantity += 1
            } else {
              item.quantity = item.quantity
              acc.push(item)
            }
            return acc
          }, [])
          if (combined_items.length > 0) {
            fetch(window.routes.cartAddUrl + '.js', {
              body: JSON.stringify({ items: combined_items }),
              credentials: 'same-origin',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
              }
            }).then(function (cart) {
              return cart.json();
            }).then(function (data) {
              setTimeout(function () {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
              }, 200)
            });
          }
        // }
      });
    }

  },

  fetchRebuySources: function (callback) {

    if (this.rebuy_sources) {
      if (typeof callback === 'function') {
        callback()
      }
    } else {
      $.getJSON(this.rebuy_base_url + '/api/v1/sources?key=' + this.api_key, function (rebuy_sources) {
        this.rebuy_sources = rebuy_sources.data.filter(function (source) {
          return source.name.toLowerCase().indexOf('discount') > -1
        })
        this.rebuy_sources_gift_product = rebuy_sources.data.filter(function (source) {
          return source.name.toLowerCase().indexOf('free gift') > -1
        })
        if (typeof callback === 'function') {
          callback()
        }
      }.bind(this))
    }

  },
  fetchRebuyProducts: function () {
    var _this = this

    this.fetchRebuySources(function () {
      _this.requests = _this.rebuy_sources.map(function (source) {
        var url = _this.rebuy_base_url + source.id + '?shopify_product_ids=' + _this.product_id + '&key=' + _this.api_key
        return $.getJSON(url, function (response) {
          var parts = source.name.split(' ')
          var discount_percent = parts[1]

          _this.discount_sources.push({
            id: source,
            products: response.data,
            name: source.name,
            discount_percent: parseInt(discount_percent)
          })

        })
      })
      _this.requestgiftproduct = _this.rebuy_sources_gift_product.map(function (source) {
        var url = _this.rebuy_base_url + source.id + '?shopify_product_ids=' + _this.product_id + '&key=' + _this.api_key
        return $.getJSON(url, function (response) {
          _this.gift_sources.push({
            id: source,
            products: response.data,
            name: source.name,
            discount_percent: 100,
            metadata: response.metadata
          })
        })
      })

      $.when.all(_this.requests).then(function (objects) {

        _this.products = _this.sortProducts(_this.discount_sources)
        _this.prerenderProducts()
      })
      // running all request gift product
      $.when.all(_this.requestgiftproduct).then(function (objects) {
        _this.giftProducts = _this.sortProducts(_this.gift_sources)
        _this.prerenderProducts('gift')
      })
    })
  },
  sortProducts: function (sources) {
    var items = []
    for (var i = 0; i < sources.length; i++) {
      var source = sources[i]

      for (var ii = 0; ii < source.products.length; ii++) {
        var product = source.products[ii]
        for (var iii = 0; iii < product.variants.length; iii++) {
          var variant = source.products[ii].variants[iii]
          var discounted_price = Math.floor(variant.price * (1 - (source.discount_percent / 100))) //Always round down on the discounted_price
          var price = parseFloat(variant.price)
          var discount_percentage = ((price - discounted_price) / price) * 100 //Calcuate percentage based on the actual savings and round down
          var discount_percentage_rounded = Math.floor(discount_percentage) //Calcuate percentage based on the actual savings and round down
          let source_match_array = []

          if (source.metadata) {
            let source_match = source.metadata
            if (source_match.matched_rules) {
              let match_rules = source_match.matched_rules
              if (match_rules[0]) {
                let i = match_rules[0].output
                if (i.length > 0) {
                  for (let j = 0; j < i.length; j++) {
                    for (let k = 0; k < i[j].products.length; k++) {
                      source_match_array.push(i[j].products[k].product_id)
                    }
                  }
                }
              }
            }
          }

          const count = source_match_array.reduce((data, pound) => {
            data[pound] = (data[pound] || 0) + 1;
            return data;
          }, {})

          items.push({
            variant_id: variant.id,
            product_id: product.id,
            quantity: count[product.id],
            source: source,
            price,
            discounted_price,
            discount_percentage,
            discount_percentage_rounded
            // product: product,
            // variant: variant,
          })
        }
      }
    }
    return items.sort(function (a, b) { return a.discounted_price - b.discounted_price })
  },

  prerenderProducts: function (type = 'default') {

    var queryString = this.getSearchQueryString(this.products)
    if (type == 'gift') {
      queryString = this.getSearchQueryString(this.giftProducts)
      $.get(window.routes.searchUrl + '?view=rebuy-gift-product&type=product&q=' + queryString, function (response) {
        this.shopify_gift_product_html = response
        this.renderProducts(false)
      }.bind(this), 'json')
    } else {
      $.get(window.routes.searchUrl + '?view=rebuy-discount-upsell&type=product&q=' + queryString, function (response) {
        this.shopify_products_html = response
        this.renderProducts(true)
        document.querySelectorAll('.discount-upsell__list [data-discount]').forEach((el) => {
          var discount = el.dataset.discount
          if (discount <= 0) {
            el.querySelector('.Price.Price--compareAt').style.display = 'none'
            el.querySelector('.ProductMeta__Save').style.display = 'none'
          }
        })
        this.loading(false)
      }.bind(this), 'json')
    }

  },
  renderProducts: function (addToDiscountCalculation) {
    // Use original rebuy data to get sort order
    if (typeof this.products == 'undefined') {
      this.products = [];
    }
    var products_html = this.products.map(function (p) {
      if (!this.shopify_products_html) {
        return ''
      }
      var html = this.shopify_products_html[p.variant_id];
      if (!html) {
        console.log('product not found', p.product_id, p.variant_id)
        return ''
      }
      var discount_price = p.source.discount_percent == 100
        ? theme.Currency.formatMoney(0, theme.moneyFormat)
        : theme.Currency.formatMoney(Math.floor(parseInt(p.discounted_price)) * 100, theme.moneyFormat)
      html = html.replace(/{{ price }}/g, discount_price);

      if (addToDiscountCalculation) {
        this.total_discount += p.discounted_price
        this.total_price += p.price
      }

      html = html.replace(/{{ discount }}/g, p.discount_percentage_rounded)
      return html
    }.bind(this));
    var discount_percentage = Math.floor(((parseInt(this.total_price) - parseInt(this.total_discount)) / parseInt(this.total_price)) * 100);
    if (this.showSaveUpToLabel && isNaN(discount_percentage) == false) {
      document.querySelectorAll('.discount-upsell .ProductMeta__Save').forEach((el) => {
        if (discount_percentage > 0) {
          el.style.display = 'block'
          if (el.querySelector("strong")) {
            el.querySelector("strong").innerHTML = Math.floor(discount_percentage) + "%";
          }
          if (el.querySelector("span") && el.querySelector("span").childNodes[0]) {
            el.querySelector("span").childNodes[0].nodeValue = window.theme.string.saveUpTo + ' '
            el.querySelector("span").style.display = 'inline-block'
          }
        } else {
          el.style.display = 'none'
        }
      })

      //ProductMeta__Save saveUpTo
      document.querySelectorAll('.saveUpTo').forEach((el) => {
        if (discount_percentage > 0) {
          el.innerHTML = window.theme.string.saveUpTo + ' <strong>' + Math.floor(discount_percentage) + '%</strong>';
          el.style.display = 'inline-block'
        } else {
          el.style.display = 'none'
        }
      })
    } else {
      document.querySelectorAll('.discount-upsell .ProductMeta__Save').forEach((el) => {
        el.style.display = 'none'
      })
    }
    document.querySelectorAll('.saveUpTo.alwaysVisible').forEach((el) => {
      if (discount_percentage > 0) {
        el.innerHTML = window.theme.string.saveUpTo + ' <strong>' + Math.floor(discount_percentage) + '%</strong>';
        el.style.display = 'inline-block'
      } else {
        el.style.display = 'none'
      }

    })
    this.showMoreButtons.forEach((button) => {
      if (this.products.length > 4) {
        button.classList.add("show-more");
        button.style.display = "";
      } else {
        button.style.display = "none";
      }
    })

    if (products_html.length > 0) {
      var has_li_html = false;
      this.$container.each(function () {
        $subContainer = $(this)
        $subContainer.find('ul').html(products_html.join(''))
        if ($subContainer.find('ul li').length > 0) {
          has_li_html = true
        }
        $subContainer.find('ul li').each(function (index) {
          var $this = $(this)
          if (index > 3) {
            $this.hide();
          }
          var discount_percent = $this.data('discount')
          if (discount_percent == 100) {
            $this.find('input[name="id"]').prop('checked', true)
            $this.find('[data-tiered-option-price]').remove()
          } else {
            //Manipulate tiered pricing options
            $this.find('[data-tiered-option-price]').each(function (idx, el) {
              var $tier_option = $(this)
              var tiered_price = $tier_option.data('tiered-option-price')
              var final_price = tiered_price * (1 - (discount_percent / 100));
              if (idx == 0) {
                final_price = Math.floor((final_price / 100)) * 100
              }
              var price_formatted = theme.Currency.formatMoney(Math.floor(parseInt(final_price)), theme.moneyFormat)
              $tier_option.html(idx + 1 + ' - ' + price_formatted)
            })
          }
        })
      })


      document.querySelectorAll(".discount-upsell__list li").forEach((input) => {
        if (input.querySelector(".Form__CheckboxWrapper  input").checked) {
          input.classList.add('checked');
        }
        input.querySelector(".Form__CheckboxWrapper  input").addEventListener("click", function (e) {
          e.preventDefault();
          input.querySelector(".Form__CheckboxWrapper  input").checked = !input.querySelector(".Form__CheckboxWrapper  input").checked;
          if (input.querySelector(".Form__CheckboxWrapper  input").checked) {
            input.classList.remove('checked');
          } else {
            input.classList.add('checked');
          }
        })
        input.addEventListener("click", function (e) {
          let clickedOnQty = false;
          if (input.querySelector(".QuantitySelector")) {
            if (input.querySelector(".QuantitySelector").contains(e.target)) {
              clickedOnQty = true;
            }
          }
          if (!clickedOnQty) {
            input.querySelector(".Form__CheckboxWrapper  input").checked = !input.querySelector(".Form__CheckboxWrapper  input").checked;
            if (input.classList.contains('checked')) {
              input.classList.remove('checked');
            } else {
              input.classList.add('checked');
            }
          } else {
            let inputQtyVal = parseInt(input.querySelector('.QuantitySelector input').value);
            if (inputQtyVal > 0) {
              input.querySelector(".Form__CheckboxWrapper input").checked = true;
              input.classList.add('checked');
            } else {
              input.querySelector(".Form__CheckboxWrapper input").checked = false;
              input.classList.remove('checked');
            }
          }
        })
      });
      if (has_li_html == true) {
        this.$container.show();
      } else {
        document.querySelectorAll('.saveUpTo').forEach((el) => {
          el.style.display = 'none'
        })
      }
    }
    if (typeof this.giftProducts == 'undefined') {
      this.giftProducts = [];
    }
    var gift_product_html = this.giftProducts.map(function (p) {
      if (!this.shopify_gift_product_html) {
        return ''
      }

      var html = this.shopify_gift_product_html[p.variant_id];
      if (!html) {
        console.log('product not found', p.product_id, p.variant_id)
        return ''
      }

      var discount_price = p.source.discount_percent == 100
        ? theme.Currency.formatMoney(0, theme.moneyFormat)
        : theme.Currency.formatMoney(Math.floor(parseInt(p.discounted_price)) * 100, theme.moneyFormat)
      html = html.replace(/{{ price }}/g, discount_price);

      html = html.replace(/{{ discount }}/g, p.discount_percentage_rounded)

      if (p.quantity && p.quantity != 'undefined' && p.quantity != undefined) {
        html = html.replace(/{{ quantity }}/g, p.quantity)
        html = html.replace(/{{ quantity_line }}/g, p.quantity)
      } else {
        html = html.replace(/{{ quantity }}/g, 1)
        html = html.replace(/{{ quantity_line }}/g, 1)
      }
      return html
    }.bind(this));
    let _this = this;
    if (gift_product_html.length > 0) {
      this.$containergift.find('.rebuy-gift-product').html(gift_product_html.join(''));
      this.$containergift.show();
      _this.resizeGiftProduct();
    }
  },
  getSearchQueryString: function (items) {
    if (!items) {
      return ''
    }
    return items.map(function (item) {
      return 'id:' + item.product_id;
    }).join(' OR ');
  }
}


if (window.theme.cartEnableTerms) {
  Dtails.cartEnableTerms();
}

if (window.theme.template == 'product' || window.theme.template == 'collection') {
  Dtails.RebuyModal.init()
}
if (window.theme.template == 'product') {
  Dtails.DiscountUpsell.init()
}
if (window.theme.template == 'collection') {
  Dtails.DiscountUpsell.collectionInit()
}
Dtails.DiscountUpsell.initGlobalEventHandlers()

document.addEventListener('variant:changed', function (event) {
  var variant = event.detail.variant;
  if (typeof variant != 'undefined') {
    if ($('[data-specs-variant-id="' + variant.id + '"]').length) {
      $('[data-specs-variant-id]').hide()
      $('[data-specs-variant-id="' + variant.id + '"]').show()
    } 
  }
});

if (window.theme.template == 'collection') {
  Dtails.productCartAjax()
}

Dtails.AutomaticDiscount.load();

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    var topButton = document.querySelector('.ProductForm__AddToCart').offsetTop;
    if (!topButton) {
      return
    }
    window.addEventListener('scroll', () => {
      if (window.scrollY >= topButton) {
        this.show();
      } else {
        this.hide();
      }
    });
    this.querySelector('.ProductForm__Sticky_AddToCart').addEventListener('click', (e) => {
      e.preventDefault();
      if (document.querySelector('.ProductForm__AddToCart')) {
        document.querySelector('.ProductForm__AddToCart').click();
      }
      this.hide();
    })
  }

  async show() {
    this.setAttribute('open', '');
    var minHeight = this.querySelector('.ProductForm__Actions').clientHeight + 30
    if (minHeight < 80) {
      if (this.querySelector('.sticky-stock-text') && this.querySelector('.sticky-stock-text').offsetHeight > 0) {
        minHeight += 57
        this.style.minHeight = minHeight + 'px';
      } else {
        this.style.minHeight = 0 + 'px';
      }
    }
  }

  hide() {
    this.removeAttribute('open')
  }
}

customElements.define('sticky-add-cart', StickyAddCart)
